import React from "react";
import { useSelector } from "react-redux";
import { Field, formValueSelector } from "redux-form";
import { useInterval } from "../../hooks";
import { submitFormHandler } from "./actions";
import CardLayout from "../../layouts/CardLayout";
import ProgressButton from "../../components/ProgressButton";
import { FormConfirmationCodeField } from "../../components/fields";
import classnames from "classnames";
import ResendSmsButton from "../../components/ResendSmsButton";
import styles from "./style.module.css";

const isConfirmationLooksValid = (value) => value?.length !== 6;

export default React.memo((
  {
    delay = 120000, error, resendSMS, handleSubmit, submitting, valid, goBack, ...props
  }) => {
  const [ timerStartTime, setTimerStartTime ] = React.useState(Date.now());
  const [ isTimerEnabled, setIsTimerEnabled ] = React.useState(true);
  const [ timeLeft, setTimeLeft ] = React.useState(delay / 1000);

  React.useEffect(() => {
    if (error?.type === "requestLimitReached") {
      setTimerStartTime(Date.now());
    }
  }, [ error ]);

  React.useEffect(() => {
    if (!isTimerEnabled && timerStartTime) {
      setIsTimerEnabled(true);
    }
  }, [ isTimerEnabled, timerStartTime ]);

  useInterval(() => {
    if (Date.now() - timerStartTime > delay) {
      setTimerStartTime(null);
      setIsTimerEnabled(false);
    } else {
      setTimeLeft(Math.floor((delay - (Date.now() - timerStartTime)) / 1000));
    }
  }, isTimerEnabled ? 1000 : null);

  const phone = useSelector(state => formValueSelector(props.formName)(state, "phone"));
  const verificationCode = useSelector(state => formValueSelector(props.formName)(state, "verificationCode"));

  return (
    <form className={styles.container} onSubmit={handleSubmit(submitFormHandler)}>
      <CardLayout
        backButtonHandler={goBack}
        rightHeaderLayout={
          <ResendSmsButton
            onClick={() => {
              resendSMS();
              setTimerStartTime(Date.now());
            }}
            disabled={submitting || timeLeft > 0}
            timeLeft={timeLeft}
          />
        }
        footer={
          <ProgressButton
            className={styles.button}
            variant='contained'
            type='submit'
            isFetching={submitting}
            disabled={submitting || !valid || isConfirmationLooksValid(verificationCode)}
            color="primary"
          >
            Next
          </ProgressButton>
        }
      >
        <h3 className={styles.title}>
          Enter code from SMS
        </h3>
        <span className={styles.text}>
          {`Please type the code sent to ${phone?.countryCode?.dialCode}${phone?.phone}`}
        </span>
        <Field name="verificationCode"
               component={FormConfirmationCodeField}
               disabled={submitting}
               fields={6}
               className={styles.verifyField}
        />
        <span className={styles.error}>
           {error?.message}
        </span>
        <div className={classnames(styles.text, styles.terms)}>
          <p>By clicking Next you agree with Terms of Service and Privacy Policy.</p>
          <p>
            <a href="https://ctgride.com/terms"
               target="_blank"
               rel="noopener noreferrer"
               className={styles.link}
            >
              TERMS OF SERVICE
            </a>
          </p>
          <p>
            <a href="https://ctgride.com/privacy"
               target="_blank"
               rel="noopener noreferrer"
               className={styles.link}
            >
              PRIVACY POLICY
            </a>
          </p>
        </div>
      </CardLayout>
    </form>
  );
});
